import { NamedEntityDto } from './named.dto';

export class GenderDto extends NamedEntityDto {
  // declare name: GenderName;
}

export type GenderName = 'Male' | 'Female' | 'Other';
